export const MFA_CODE = 'MFA_CODE';
export const MFA_ERROR = 'MFA_ERROR';
export const MFA_ERROR_MESSAGE = 'MFA_ERROR_MESSAGE';
